import React, {useState, useEffect} from 'react';
import { useTranslation } from 'react-i18next';

const Deadline = (props) => {
    
    var today = Date();
    var lastDay = '01/29/2023';

    lastDay = new Date(lastDay);

    let [firstRender, setFirstRender] = useState({
        firstRender: true,
    });

    const [deadline, setDeadline] = useState({
        isPassed: true,
        value: true
    });
    
    const { t } = useTranslation();

    useEffect(() => {
        if(firstRender){
            deadline.isPassed = Date.parse(today) > Date.parse(lastDay);
            deadline.value = Math.round((Date.parse(lastDay) - Date.parse(today)) / (1000 * 60 * 60 * 24));
            setDeadline(deadline);
            setFirstRender(false);
        }
    }, [deadline, firstRender, lastDay, today]);

    return (
        <div>
            <h3 className="text-center text-danger fw-bolder"> {t('call_closed')}</h3>
        </div>
    )    
}

export default Deadline;